import { Typography } from "@mui/material";
import { VIEW_POINT_CONFIG } from "hooks/useCheckViewPoint";
import { useCheckViewPoint } from "hooks/useCheckViewPoint";
import Scrollable from "v2/components/base/Scrollable/ui";
import { DiscoverLayout } from "v2/layouts/DiscoverLayout";
import { MainPageLayout } from "v2/layouts/MainPageLayout";
import CardGridLayout from "v2/layouts/CardGridLayout";

export const PROJECT_LIST = [
  {
    id: "vooi",
    title: "VOOI",
    description:
      "Derivative marketplace to access crypto market by trading stocks, commodities and other markets.",
    image: "/airdrop-vooi-logo.webp",
    isActive: true,
  },
  {
    // id: "project-2",
    // title: "???",
    // description: "Stay tuned for more projects",
    // image: "/mock-logo-2.webp",
    isActive: false,
  },
  {
    // id: "project-3",
    // title: "???",
    // description: "Stay tuned for more projects",
    // image: "/mock-logo-3.webp",
    isActive: false,
  },
];

const Airdrop = () => {
  const isMobile = useCheckViewPoint(VIEW_POINT_CONFIG.MOBILE);

  return (
    <MainPageLayout
      Title={<Typography variant={isMobile ? "mobile-h3" : "mobile-h2"}>Earn Airdrop</Typography>}>
      <DiscoverLayout
        Filters={<></>}
        Scrollable={
          <Scrollable isLoading={false} isEmpty={false} hasAllFetched={true} loadMoreRef={() => {}}>
            <CardGridLayout cardsConfig={PROJECT_LIST} />
          </Scrollable>
        }
      />
    </MainPageLayout>
  );
};

export { Airdrop };
